import { NavigateOptions } from 'react-router-dom';
import { Grid, Pagination as PaginationBar } from 'antd';
import { useTranslation } from 'react-i18next';
import {
	PagingConfig,
	FunctionaryInfo,
	FunctionaryList,
	UserRole,
	ApplicationsFilter,
} from '../../../shared/VolunteerApplicationServiceTypes';
import isEmpty from 'lodash/isEmpty';
import { FunctionaryCard } from './FunctionaryCard';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import { useRedirectToLogin } from '../../../hooks/useRedirectToLogin';
import { FunctionaryTableView } from './FunctionariesTableList';

const EmptyList = () => {
	const { t } = useTranslation();
	const { role } = useRedirectToLogin();

	return (
		<div className="text-center font-bold text-lg text-secondary-black">
			{role === UserRole.ADMIN ? t('noFunctionaries') : t('noProposers')}
		</div>
	);
};

const { useBreakpoint } = Grid;

export const FunctionariesList = ({
	data: { functionary, pagination },
	onPageChange,
	onEditClick,
	pageConfig,
	navigateWithFunctionarySrcmId,
	onFilterChange,
}: {
	data: FunctionaryList;
	onPageChange: (page: number, pageSize: number) => void;
	onEditClick: (functionary: FunctionaryInfo) => void;
	pageConfig: PagingConfig;
	navigateWithFunctionarySrcmId: (
		route: string,
		functionarySIdParam?: string,
		params?: NavigateOptions
	) => void;
	onFilterChange: (filterParam: ApplicationsFilter) => void;
}) => {
	const screens = useBreakpoint();
	const isMobile = !screens.sm;

	if (
		isEmpty(pagination.totalNoOfRecords) ||
		pagination.totalNoOfRecords === 0
	) {
		return <EmptyList />;
	}

	const proposerCards = functionary?.map((proposer) => (
		<div className="mb-[16px]" key={proposer.srcmId}>
			<FunctionaryCard {...proposer} onEditClick={onEditClick} />{' '}
		</div>
	));

	return (
		<div className="flex flex-col gap-6">
			{isMobile ? (
				<>
					{proposerCards}
					<div className="flex justify-center w-full">
						<PaginationBar
							current={pageConfig.pageNo ?? 1}
							total={pagination.totalNoOfRecords}
							showTotal={(total, range) =>
								`${range[0]}-${range[1]} of ${total} items`
							}
							defaultPageSize={pageConfig.pageSize ?? DEFAULT_PAGE_SIZE}
							onChange={onPageChange}
						/>
					</div>
				</>
			) : (
				<FunctionaryTableView
					functionaries={functionary}
					pagination={pagination}
					paging={pageConfig}
					onPageChange={onPageChange}
					navigateWithFunctionarySrcmId={navigateWithFunctionarySrcmId}
					onFilterChange={onFilterChange}
				/>
			)}
		</div>
	);
};
